import { TabDatosPersonales } from './tabsIglesia/TabDatosPersonales';
import { TabDatosContacto } from './tabsIglesia/TabDatosContacto';
import { TabDatosInstitucionales } from './tabsIglesia/TabDatosInstitucionales';
import { TabDatosContables } from './tabsIglesia/TabDatosContables';
import { TabMinistrosDependientes } from './tabsIglesia/TabMinistrosDependientes';
import { TabDatosBancarios } from './tabsIglesia/TabDatosBancarios';
import { TabFicheroCulto } from './tabsIglesia/TabFicheroCulto';
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import Main from '../componentes/Main';
import Axios from 'axios';
import Modal from '../componentes/Modal';
import useModal from '../hooks/useModal';
import Loading from '../componentes/Loading';
import BusquedaSinForm from '../componentes/BusquedaSinForm';
import BusquedaProvincias from '../componentes/BusquedaProvincias';
import Swal from 'sweetalert2';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { seleccionarTextoInput, traerAbrirUrl,traerUrl } from '../Helpers/utilidades-globales';
import ReactTooltip from 'react-tooltip';
import { LoaderCircular } from '../componentes/LoaderCircular';
import { Button, Typography, Tabs, TabsHeader, Tab, TabsBody, TabPanel } from '@material-tailwind/react';
import { MagnifyingGlassCircleIcon, XCircleIcon,TrashIcon, PlusCircleIcon, CheckIcon } from '@heroicons/react/24/outline';
import GoBack from '../componentes/GoBack';
import { useContextoGlobal } from '../Context/contextoGlobal';
import {transformarIso8601} from '../Helpers/fechas';
    // Inicio agregado por PS el 12/08/2026 por tema fichero de culto adjunto
import { PanelAdjuntosDinamico } from '../Vistas/tramites/componentes/modulos/componentes/PanelAdjuntosDinamico';
import { subirAdjunto, eliminarArchivos }  from '../Vistas/tramites/componentes/modulos/index.js';
    // Fin agregado por PS el 12/08/2026 por tema fichero de culto adjunto

const tiposIgParaRegiones = [0,1, 2, 3];
// Mapea cada campo validado por Yup a la pestaña donde se edita, para poder
// llevar al usuario al primer error cuando el guardado se bloquea por validación.
// Todos estos campos viven en las 3 primeras pestañas, visibles tanto en alta como en edición.
const CAMPO_A_TAB_IGLESIA = {
    nombre_iglesia: 'datos_personales',
    id_region: 'datos_personales',
    id_distrito: 'datos_personales',
    id_tipo_iglesia: 'datos_personales',
    id_pastor_UAD: 'datos_personales',
    id_encargado_UAD: 'datos_personales',
    nombre_pastor: 'datos_personales',
    nombre_encargado: 'datos_personales',
    pastor_uad: 'datos_personales',
    encargado_uad: 'datos_personales',
    direccion: 'datos_contacto',
    localidad: 'datos_contacto',
    cod_postal: 'datos_contacto',
    barrio: 'datos_contacto',
    telefono: 'datos_contacto',
    fax: 'datos_contacto',
    id_provincia: 'datos_contacto',
    observaciones: 'datos_contacto',
    cant_miembros: 'datos_institucionales',
    fich_culto: 'datos_institucionales',
    libro_cont: 'datos_institucionales',
    seguro: 'datos_institucionales',
    hab_municip: 'datos_institucionales',
    dispensario: 'datos_institucionales',
    comedor: 'datos_institucionales',
    colegio: 'datos_institucionales',
    rehabilit: 'datos_institucionales',
    'hogar_niños': 'datos_institucionales',
    predio_recreat: 'datos_institucionales',
};
const tabsIglesiaAlta = ['datos_personales', 'datos_contacto', 'datos_institucionales'];
const tabsIglesiaEdicion = ['datos_personales', 'datos_contacto', 'datos_institucionales', 'datos_contables', 'ministros_dependientes', 'datos_bancarios', 'fichero_culto'];

export default function AbmIglesia({ id_iglesia, finalizarAltaOcopia, esModal, id_copia, usuario, esVisualizacion, finalizarIglesiaSeleccionado }) {
    const idIglesiaActual = Number(id_iglesia) > 0 ? Number(id_iglesia) : null;

    // estados flags 
    const [cargandoDatosTablasGenerales, setCargandoTablasGenerales] = useState(false);
    const [cargandoDatosIglesia, setCargandoDatosIglesia] = useState(false);
    const [grabandoDatosIglesia, setGrabandoDatosIglesia] = useState(false);
    const [tablasCargadas, setTablasCargadas] = useState(false)
    const [huboError, setHuboError] = useState(false)
    const [tituloAbm, setTituloAbm] = useState('');
    const [tituloCerrar, setTituloCerrar] = useState('');
    const [contadorOperaciones, setContadorOperaciones] = useState(0);
    // vectores de selección de formulario

    const [vectorDias, setVectorDias] = useState([]);
    const [vectorMeses, setVectorMeses] = useState([]);
    const [vectorAnios, setVectorAnios] = useState([]);

    // vectores de selección de otras operaciones
    const [provincias, setProvincias] = useState([]);
    const [nacionalidades, setNacionalidades] = useState([]);
    const [estadosCiviles, setEstadosCiviles] = useState([]);
    const [regiones, setRegiones] = useState([])
    const [distritos, setDistritos] = useState([]);
    const [rangos, setRangos] = useState([]);
    const [tiposIglesias, setTiposIglesias] = useState([]);
    const [obrerosUad, setObrerosUad] = useState([]);

    // Variables para manejar otras operaciones

    const [contadorModificaciones, setContadorModificaciones] = useState(0)
    const [datosParaImpresiones, setDatosParaImpresiones] = useState(null)
    const [buscarPastorUad, setBuscarPastorUad] = useState(false)
    const [buscarEncargadoUad, setBuscarEncargadoUad] = useState(false)
    const [buscarProvincias, setBuscarProvincias] = useState(false)

    const [balances, setBalances] = useState([])
    const [periodosBalance, setPeriodosBalance] = useState([])
    const [nuevoBalancePeriodo, setNuevoBalancePeriodo] = useState('');
    const [nuevoBalanceFecha, setNuevoBalanceFecha] = useState('');

    const normalizarBalances = (items = []) => {
        if (!Array.isArray(items)) {
            return [];
        }

        return items.map(item => ({
            ...item,
            periodo: item.periodo || item.anio_fiscal || '',
            id_año_fiscal: item.id_año_fiscal || null
        }));
    };

    const normalizarFechaFormulario = (fecha) => {
        if (!fecha) {
            return '';
        }

        return String(fecha).substring(0, 10);
    };

    const cargarBalancesIglesia = async (idIglesia) => {
        const { data } = await Axios.get(`/api/tablasgenerales/v2/iglesia/balances/${idIglesia ? idIglesia : 0}`);
        setBalances(normalizarBalances(data));
    };

    const [ministrosDependientes, setMinistrosDependientes] = useState([])
    const [minDepSeleccionado, setMinDepSeleccionado] = useState(null)
    const [listaObreros, setListaObreros] = useState([])
    const [nuevoMinistroSeleccionado, setNuevoMinistroSeleccionado] = useState('')

    const cuentaInit = {
        id_cuenta: null,
        nombre: '',
        cbu: '',
        f_apertura: '',
        id_tipo_cuenta: '',
        usd: false,
        nro_cuenta: '',
        id_banco: '',
        nro_sucursal: '',
        sucursal: '',
        localidad: '',
        observaciones: '',
        poder_pagado: false,
        f_rc: '',
        nro_rc: '',
        firmantes: [
            { nombre: '', doc: '', contacto: '' },
            { nombre: '', doc: '', contacto: '' },
            { nombre: '', doc: '', contacto: '' },
            { nombre: '', doc: '', contacto: '' }
        ]
    };
    const [cuentasBancarias, setCuentasBancarias] = useState([]);
    const [cuentaActiva, setCuentaActiva] = useState(cuentaInit);
    const [bancosList, setBancosList] = useState([]);
    const [tiposCuentasList, setTiposCuentasList] = useState([]);

    useEffect(() => {
        let isMounted = true;
        if (idIglesiaActual) {
            Axios.get('/api/tablasgenerales/listado/entes')
                .then(res => { if(isMounted) setListaObreros(res.data) })
                .catch(err => console.error(err));
            Axios.get(`/api/tablasgenerales/iglesia/dependientes/${idIglesiaActual}`)
                .then(res => { if(isMounted) setMinistrosDependientes(res.data) })
                .catch(err => console.error(err));
            Axios.get(`/api/tablasgenerales/v2/iglesia/bancos/${idIglesiaActual}`)
                .then(res => { 
                    if(isMounted && Array.isArray(res.data)) {
                        const mapBancos = res.data.map(c => ({
                            id_cuenta: c.id_iglesia_banco,
                            nombre: c.nombre,
                            cbu: c.CBU,
                            f_apertura: c.f_apertura ? c.f_apertura.substring(0,10) : '',
                            id_tipo_cuenta: c.id_tipo_cuenta_bco,
                            usd: c.dolares ? true : false,
                            nro_cuenta: c.nro_cuenta_bco,
                            id_banco: c.id_banco,
                            nro_sucursal: c.nro_sucursal,
                            sucursal: c.sucursal_bco,
                            localidad: c.localidad_bco,
                            observaciones: c.observaciones || c.obs || '',
                            poder_pagado: c.pago_poder ? true : false,
                            f_rc: c.f_recibo ? c.f_recibo.substring(0,10) : '',
                            nro_rc: c.nro_recibo,
                            firmantes: [
                                { nombre: c.firmante1||'', doc: c.doc_firmante1||'', contacto: c.contacto_firmante1||'' },
                                { nombre: c.firmante2||'', doc: c.doc_firmante2||'', contacto: c.contacto_firmante2||'' },
                                { nombre: c.firmante3||'', doc: c.doc_firmante3||'', contacto: c.contacto_firmante3||'' },
                                { nombre: c.firmante4||'', doc: c.doc_firmante4||'', contacto: c.contacto_firmante4||'' },
                                { nombre: c.firmante5||'', doc: c.doc_firmante5||'', contacto: c.contacto_firmante5||'' }
                            ]
                        }));
                        setCuentasBancarias(mapBancos);
                    } 
                })
                .catch(err => console.error(err));
        }

        // Cargar listas globales de bancos
        Axios.get('/api/tablasgenerales/bancos')
            .then(res => { if(isMounted) setBancosList(res.data?.recordset || res.data || []) })
            .catch(err => console.error(err));
            
        Axios.get('/api/tablasgenerales/tipocuentasbanco')
            .then(res => { if(isMounted) setTiposCuentasList(res.data?.recordset || res.data || []) })
            .catch(err => console.error(err));

        return () => { isMounted = false; }
    }, [idIglesiaActual]);

    const handleGuardarCuentaBancaria = async () => {
        if(!idIglesiaActual) {
            Swal.fire('Atención', 'Debe grabar la iglesia primero', 'warning');
            return;
        }
        try {
            setGrabandoDatosIglesia(true);
            const body = {
                id_iglesia_banco: cuentaActiva.id_cuenta || null,
                id_iglesia: idIglesiaActual,
                nombre: cuentaActiva.nombre || '',
                CBU: cuentaActiva.cbu || '',
                f_apertura: cuentaActiva.f_apertura ? cuentaActiva.f_apertura + 'T00:00:00.000Z' : null,
                id_banco: cuentaActiva.id_banco || null,
                id_tipo_cuenta_bco: cuentaActiva.id_tipo_cuenta || null,
                dolares: cuentaActiva.usd || false,
                nro_cuenta_bco: cuentaActiva.nro_cuenta || '',
                datos_firmantes: '',
                pago_poder: cuentaActiva.poder_pagado ? 1 : 0,
                nro_recibo: cuentaActiva.nro_rc || '',
                f_recibo: cuentaActiva.f_rc ? cuentaActiva.f_rc + 'T00:00:00.000Z' : null,
                sucursal_bco: cuentaActiva.sucursal || '',
                nro_sucursal: cuentaActiva.nro_sucursal || '',
                localidad_bco: cuentaActiva.localidad || '',
                observaciones: cuentaActiva.observaciones || ''
            };

            for(let i=0; i<5; i++) {
                if(cuentaActiva.firmantes && cuentaActiva.firmantes[i]) {
                    body['firmante' + (i+1)] = cuentaActiva.firmantes[i].nombre || '';
                    body['doc_firmante' + (i+1)] = cuentaActiva.firmantes[i].doc || '';
                    body['contacto_firmante' + (i+1)] = cuentaActiva.firmantes[i].contacto || '';
                } else {
                    body['firmante' + (i+1)] = '';
                    body['doc_firmante' + (i+1)] = '';
                    body['contacto_firmante' + (i+1)] = '';
                }
            }

            await Axios.post('/api/tablasgenerales/v2/iglesia/banco', body);

            const resulC = await Axios.get(`/api/tablasgenerales/v2/iglesia/bancos/${idIglesiaActual}`);
            if(Array.isArray(resulC.data)) {
                const mapBancos = resulC.data.map(c => ({
                    id_cuenta: c.id_iglesia_banco,
                    nombre: c.nombre,
                    cbu: c.CBU,
                    f_apertura: c.f_apertura ? c.f_apertura.substring(0,10) : '',
                    id_tipo_cuenta: c.id_tipo_cuenta_bco,
                    usd: c.dolares ? true : false,
                    nro_cuenta: c.nro_cuenta_bco,
                    id_banco: c.id_banco,
                    nro_sucursal: c.nro_sucursal,
                    sucursal: c.sucursal_bco,
                    localidad: c.localidad_bco,
                    observaciones: c.observaciones || c.obs || '',
                    poder_pagado: c.pago_poder ? true : false,
                    f_rc: c.f_recibo ? c.f_recibo.substring(0,10) : '',
                    nro_rc: c.nro_recibo,
                    firmantes: [
                        { nombre: c.firmante1||'', doc: c.doc_firmante1||'', contacto: c.contacto_firmante1||'' },
                        { nombre: c.firmante2||'', doc: c.doc_firmante2||'', contacto: c.contacto_firmante2||'' },
                        { nombre: c.firmante3||'', doc: c.doc_firmante3||'', contacto: c.contacto_firmante3||'' },
                        { nombre: c.firmante4||'', doc: c.doc_firmante4||'', contacto: c.contacto_firmante4||'' },
                        { nombre: c.firmante5||'', doc: c.doc_firmante5||'', contacto: c.contacto_firmante5||'' }
                    ]
                }));
                setCuentasBancarias(mapBancos);
            }
            setCuentaActiva(cuentaInit);
            setGrabandoDatosIglesia(false);
            Swal.fire('Okey', 'Cuenta bancaria guardada con éxito', 'success');
        } catch(err) {
            setGrabandoDatosIglesia(false);
            console.error(err);
            Swal.fire('Error', 'No se pudo guardar la cuenta bancaria', 'error');
        }
    };

    const handleEliminarCuentaBancaria = async (id_cuenta) => {
        Swal.fire({
            title: "¿Está seguro que desea eliminar la cuenta bancaria?",
            type: "warning",
            confirmButtonText: 'Sí, eliminar!',
            cancelButtonText: "No, cancelar!",
            showCancelButton: true
        }).then(async resultado => {
            if(resultado.value) {
                try {
                    setGrabandoDatosIglesia(true);
                    await Axios.delete(`/api/tablasgenerales/v2/iglesia/banco/${id_cuenta}`);
                    setCuentasBancarias(cuentasBancarias.filter(c => c.id_cuenta !== id_cuenta));
                    if(cuentaActiva.id_cuenta === id_cuenta) setCuentaActiva(cuentaInit);
                    setGrabandoDatosIglesia(false);
                    Swal.fire('Okey', 'Cuenta eliminada', 'success');
                } catch(err) {
                    setGrabandoDatosIglesia(false);
                    console.error(err);
                    Swal.fire('Error', 'No se pudo eliminar la cuenta', 'error');
                }
            }
        });
    };

    const handleFirmanteChange = (idx, field, value) => {
        const nuevosFirmantes = [...cuentaActiva.firmantes];
        if(!nuevosFirmantes[idx]) nuevosFirmantes[idx] = { nombre: '', doc: '', contacto: '' };
        nuevosFirmantes[idx][field] = value;
        setCuentaActiva({ ...cuentaActiva, firmantes: nuevosFirmantes });
    }

    const handleAgregarMinistroInfo = async () => {
        if(!idIglesiaActual) {
            Swal.fire('Atención', 'Debe grabar la iglesia primero', 'warning');
            return;
        }
        if(!nuevoMinistroSeleccionado) {
            Swal.fire('Atención', 'Debe seleccionar un ministro', 'warning');
            return;
        }
        try {
            setGrabandoDatosIglesia(true);
            // Alta de vínculo: ruta real del backend = POST /vinculos/alta/:id_obrero con { id_iglesia }
            await Axios.post(`/api/tablasgenerales/vinculos/alta/${nuevoMinistroSeleccionado}`, { id_iglesia: idIglesiaActual });
            const resultMin = await Axios.get(`/api/tablasgenerales/iglesia/dependientes/${idIglesiaActual}`);
            setMinistrosDependientes(resultMin.data);
            setNuevoMinistroSeleccionado('');
            setGrabandoDatosIglesia(false);
            Swal.fire('Okey', 'Ministro agregado con éxito', 'success');
        } catch(err) {
            setGrabandoDatosIglesia(false);
            console.error(err);
            Swal.fire('Error', 'No se pudo agregar el ministro', 'error');
        }
    };

    const handleEliminarMinistroInfo = async (id_min_eliminar) => {
        try {
            setGrabandoDatosIglesia(true);
            // Baja de vínculo: ruta real del backend = DELETE /vinculos/baja/:id_obrero
            await Axios.delete(`/api/tablasgenerales/vinculos/baja/${id_min_eliminar}`);
            const resultMin = await Axios.get(`/api/tablasgenerales/iglesia/dependientes/${idIglesiaActual}`);
            setMinistrosDependientes(resultMin.data);
            setGrabandoDatosIglesia(false);
            Swal.fire('Okey', 'Ministro eliminado', 'success');
        } catch(err) {
            setGrabandoDatosIglesia(false);
            console.error(err);
            Swal.fire('Error', 'No se pudo eliminar el ministro', 'error');
        }
    };

    const handleAgregarBalance = async () => {
        if(!idIglesiaActual) {
            Swal.fire('Atención', 'Debe grabar la iglesia primero (arriba) antes de añadir balances', 'warning');
            return;
        }
        if(!nuevoBalancePeriodo || !nuevoBalanceFecha) {
            Swal.fire('Atención', 'Debe indicar periodo y fecha', 'warning');
            return;
        }
        try {
            setGrabandoDatosIglesia(true);
            const idAñoFiscal = Number(nuevoBalancePeriodo);
            await Axios.post('/api/tablasgenerales/v2/iglesia/balance', {
                id_iglesia: idIglesiaActual,
                id_año_fiscal: idAñoFiscal,
                f_entrega: nuevoBalanceFecha
            });
            await cargarBalancesIglesia(idIglesiaActual);
            setNuevoBalancePeriodo('');
            setNuevoBalanceFecha('');
            setGrabandoDatosIglesia(false);
            Swal.fire('Okey', 'Balance agregado con éxito', 'success');
        } catch(err) {
            setGrabandoDatosIglesia(false);
            console.error(err);
            Swal.fire('Error', 'No se pudo agregar el balance', 'error');
        }
    };

    const handleEliminarBalance = async (balance) => {
        try {
            setGrabandoDatosIglesia(true);
            await Axios.delete(`/api/tablasgenerales/v2/iglesia/balance/${idIglesiaActual}/${balance.id_año_fiscal}`);
            await cargarBalancesIglesia(idIglesiaActual);
            setGrabandoDatosIglesia(false);
            Swal.fire('Okey', 'Balance eliminado', 'success');
        } catch(err) {
            setGrabandoDatosIglesia(false);
            console.error(err);
            Swal.fire('Error', 'No se pudo eliminar el balance', 'error');
        }
    };

    const [diezmos, setDiezmos] = useState([])
    const [dependientes, setDependientes] = useState([])

    const { toggle, isShowing } = useModal();
    const [aula, setAula] = useState(false);
    const [valoresFormulario, setValoresFormulario] = useState(null)
    const pruebaRef = useRef(null)
    const { esCelular } = useContextoGlobal();
    const [activeTab, setActiveTab] = useState('datos_personales');
    const esEdicionIglesia = Boolean(idIglesiaActual);
    const tabsIglesiaVisibles = esEdicionIglesia ? tabsIglesiaEdicion : tabsIglesiaAlta;

    // Inicio agregado por PS el 12/08/2026 por tema fichero de culto adjunto
    const [cambiarFicheroCultoAdjunto,setCambiarFicheroCultoAdjunto]=React.useState(false);
    const [nuevoFicherCultoAdjunto,setNuevoFicheroCultoAdjunto]=React.useState(null);
    const [eliminarFicheroCultoAdjunto,setEliminarFicheroCultoAdjunto]=React.useState(false);
    // Fin agregado por PS el 12/08/2026 por tema fichero de culto adjunto

    useEffect(() => {
        if (!tabsIglesiaVisibles.includes(activeTab)) {
            setActiveTab(tabsIglesiaVisibles[0]);
        }
    }, [activeTab, tabsIglesiaVisibles]);

    // estado objeto de inicialización que inicializa los valores del abm 
    // en el alta o es cargado con los valores de la base de datos en una modificación
    // este objeto se pasa al formulario Formik para que el estado del formulario se inicialice
    // con este objeto. Luego el resto del trabajo se hace sobre el estado del formulario  
    const [objetoInicializacion, setObjetoInicializacion] = useState({
        nombre_iglesia: '',
        direccion: '',
        barrio: '',
        cod_postal: '',
        localidad: '',
        id_provincia: '',
        id_distrito: '',
        fax: '',
        telefono: '',
        cant_miembros: 0,
        fich_culto: false,
        libro_cont: false,
        seguro: false,
        hab_municip: false,
        dispensario: false,
        comedor: false,
        colegio: false,
        rehabilit: false,
        hogar_niños: false,
        predio_recreat: false,
        encargado_uad: false,
        pastor_uad: false,
        es_fundacion: false,
        forzar_igl_principal: false,
        ente_dependiente: false,
        eximida_diezmos: false,
        activar_f_pres_acta: false,
        acta_afiliacion: '',
        f_pres_acta_afil: '',
        nro_acta_culto: '',
        f_ing_minculto: '',
        f_fundacion: '',
        id_tipo_propiedad: '',
        datos_catastrales: '',
        partida: '',
        f_inicio_contrato: '',
        f_fin_contrato: '',
        f_recepcion_secnac: '',
        f_pedido_acta: '',
        f_entrega_rnc: '',
        f_entrega_secnac: '',
        nmb_entrega_secnac: '',
        dir_entrega_secnac: '',
        nro_filial: '',
        domicilio_fc: '',
        dom_fc_no_coincidente: false,
        pag_web: '',
        observaciones:'',
        email_secretaria: '',
        email_tesoreria: '',
        email_pastor: '',
        nombre_pastor: '',
        nombre_encargado: '',
        id_pastor_UAD: -1,
        id_encargado_UAD: -1,
        id_region: usuario.id_region,
        id_tipo_iglesia: 0,
        id_iglesia: idIglesiaActual,
        id_partido: '',
        activo: 1,
        ip_maq: '',
        host_maq: '',
        id_mov_web: '',
        id_iglesia_madre: '',
    })

    useEffect(() => {
        let isActive = true;

        const cargarTablasGenerales = async () => {

            setCargandoTablasGenerales(true);

            try {
                const vectorResultado = await Promise.all([
                    Axios.get('/api/tablasgenerales/tiposiglesias'),
                    Axios.get(usuario.sede_admin ? '/api/tablasgenerales/regiones/*' : `/api/tablasgenerales/regiones/${usuario.id_region}`),
                    Axios.get('/api/tablasgenerales/provincias'),
                    Axios.get(`/api/tablasgenerales/listado/obreros${usuario.sede_admin ? '/*' : `/${usuario.id_region}`}`),
                    Axios.get('/api/tablasgenerales/reportes/balances')
                ])


                if (usuario.sede_admin) {
                    if (!isActive) return;
                    setRegiones(vectorResultado[1].data);
                    setTiposIglesias(vectorResultado[0].data);
                }else{
                     if (!isActive) return;
                     setRegiones(vectorResultado[1].data.filter(i=>i.id_region==usuario.id_region));
                     setTiposIglesias(vectorResultado[0].data.filter(item => tiposIgParaRegiones.some(i => i == item.id_tipo_iglesia)));
                }
                 if (!isActive) return;
                setProvincias(vectorResultado[2].data);
                setObrerosUad(vectorResultado[3].data);
                setPeriodosBalance(vectorResultado[4].data);

                setCargandoTablasGenerales(false);
                setTablasCargadas(true)
            } catch (err) {

                console.log(err)
                const mensaje_html = `${err}`

                Swal.fire({
                    html: mensaje_html,
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                })
                setHuboError(true)
                setCargandoTablasGenerales(false);

            }
        }

        cargarTablasGenerales()

        return () => {
            isActive = false;
        }
    }, [idIglesiaActual])

    useEffect(() => {
        let isActive = true;

        const cargarDatosEdicionIglesia = async () => {
            if (!idIglesiaActual) {
                setBalances([]);
                setDiezmos([]);
                setDependientes([]);
                return;
            }

            try {
                const [balancesResponse, diezmosResponse, dependientesResponse] = await Promise.all([
                    Axios.get(`/api/tablasgenerales/v2/iglesia/balances/${idIglesiaActual}`),
                    Axios.get(`/api/tablasgenerales/mesesdiezmados/${idIglesiaActual}`),
                    Axios.get(`/api/tablasgenerales/iglesia/dependientes/${idIglesiaActual}`)
                ]);

                if (!isActive) {
                    return;
                }

                setBalances(normalizarBalances(balancesResponse.data));
                setDiezmos(diezmosResponse.data);
                setDependientes(dependientesResponse.data);
            } catch (err) {
                if (!isActive) {
                    return;
                }

                console.log(err);
                setBalances([]);
                setDiezmos([]);
                setDependientes([]);
            }
        };

        cargarDatosEdicionIglesia();

        return () => {
            isActive = false;
        };
    }, [idIglesiaActual]);

    useEffect(() => { // procesa los cierres de modales por boton cerrar y no por otro motivo
        if (!isShowing) {
            if (buscarEncargadoUad) {
                setBuscarEncargadoUad(false)
            }
            if (buscarProvincias) {
                setBuscarProvincias(false)
            }
            if (buscarPastorUad) {
                setBuscarPastorUad(false)
            }
        }
    }, [isShowing])

    useEffect(() => {

        const completarDatosDeLaIglesia = async (id) => {
            setCargandoDatosIglesia(true)
            try {

                const { data } = await Axios.get(`/api/tablasgenerales/iglesia/${id}`)

                if (!data?.length) {
                    const mensaje_html = `<p>No se encontraron datos para la iglesia ${id}</p>`

                    Swal.fire({
                        html: mensaje_html,
                        icon: 'warning',
                        confirmButtonColor: '#3085d6',
                    })

                    setCargandoDatosIglesia(false)
                    finalizarIglesiaSeleccionado()
                    return
                }

                const datosDelRecordset = data[0];

                const datosIglesia = {
                    id_provincia: noNullNumber(datosDelRecordset.id_provincia),
                    id_distrito: noNullNumber(datosDelRecordset.id_distrito),
                    nombre_iglesia: datosDelRecordset.nombre.trim(),
                    direccion: noNull(datosDelRecordset.direccion),
                    localidad: noNull(datosDelRecordset.localidad),
                    cod_postal: noNull(datosDelRecordset.cod_postal),
                    fax: noNull(datosDelRecordset.fax),
                    telefono: noNull(datosDelRecordset.telefono),
                    observaciones:noNull(datosDelRecordset.observaciones),
                    pag_web: noNull(datosDelRecordset.pagina_web),
                                        email_secretaria: noNull(datosDelRecordset.email_secretaria),
                                        email_tesoreria: noNull(datosDelRecordset.email_tesoreria),
                                        email_pastor: noNull(datosDelRecordset.email_pastor),
                    barrio: noNull(datosDelRecordset.barrio),
                    id_tipo_iglesia: noNullNumber(datosDelRecordset.id_tipo_iglesia),
                    nombre_pastor: noNull(datosDelRecordset.pastor),
                    nombre_encargado: noNull(datosDelRecordset.encargado),
                    cant_miembros: noNullNumber(datosDelRecordset.cant_miembros),
                    id_region: noNullNumber(datosDelRecordset.id_region),
                                        id_partido: noNullNumber(datosDelRecordset.id_partido),
                    id_pastor_UAD: datosDelRecordset.id_pastor_uad,
                    id_encargado_UAD: datosDelRecordset.id_encargado_uad,
                                        fich_culto: Boolean(datosDelRecordset.fich_culto),
                                        libro_cont: Boolean(datosDelRecordset.libro_cont),
                                        seguro: Boolean(datosDelRecordset.seguro),
                                        hab_municip: Boolean(datosDelRecordset.hab_municip),
                                        colegio: Boolean(datosDelRecordset.colegio),
                                        comedor: Boolean(datosDelRecordset.comedor),
                                        dispensario: Boolean(datosDelRecordset.dispensario),
                                        rehabilit: Boolean(datosDelRecordset.rehabilit),
                                        hogar_niños: Boolean(datosDelRecordset.hogar_niños),
                                        predio_recreat: Boolean(datosDelRecordset.predio_recreat),
                                        es_fundacion: Boolean(datosDelRecordset.es_fundacion),
                                        forzar_igl_principal: Boolean(datosDelRecordset.forzar_igl_principal),
                                        ente_dependiente: Boolean(datosDelRecordset.ente_dependiente),
                                        eximida_diezmos: Boolean(datosDelRecordset.eximida_diezmos),
                    pastor_uad: datosDelRecordset.id_pastor_uad ? true : false,
                    encargado_uad: datosDelRecordset.id_encargado_uad ? true : false,
                                        acta_afiliacion: noNull(datosDelRecordset?.acta_afiliacion),
                                        activar_f_pres_acta: Boolean(datosDelRecordset?.f_pres_acta_afil),
                                        f_pres_acta_afil: normalizarFechaFormulario(datosDelRecordset?.f_pres_acta_afil),
                                        nro_acta_culto: noNull(datosDelRecordset?.nro_acta_culto),
                                        f_ing_minculto: normalizarFechaFormulario(datosDelRecordset?.f_ing_minculto),
                                        f_fundacion: normalizarFechaFormulario(datosDelRecordset?.f_fundacion),
                                        id_tipo_propiedad: noNullNumber(datosDelRecordset?.id_tipo_propiedad),
                                        datos_catastrales: noNull(datosDelRecordset?.datos_catastrales),
                                        partida: noNull(datosDelRecordset?.partida),
                                        f_inicio_contrato: normalizarFechaFormulario(datosDelRecordset?.f_inicio_contrato),
                                        f_fin_contrato: normalizarFechaFormulario(datosDelRecordset?.f_fin_contrato),
                                        f_recepcion_secnac: normalizarFechaFormulario(datosDelRecordset?.f_recepcion_secnac),
                                        f_pedido_acta: normalizarFechaFormulario(datosDelRecordset?.f_pedido_acta),
                                        f_entrega_rnc: normalizarFechaFormulario(datosDelRecordset?.f_entrega_rnc),
                                        f_entrega_secnac: normalizarFechaFormulario(datosDelRecordset?.f_entrega_secnac),
                                        nmb_entrega_secnac: noNull(datosDelRecordset?.nmb_entrega_secnac),
                                        dir_entrega_secnac: noNull(datosDelRecordset?.dir_entrega_secnac),
                                        nro_filial: noNull(datosDelRecordset?.nro_filial),
                                        domicilio_fc: noNull(datosDelRecordset?.domicilio_fc),
                                        dom_fc_no_coincidente: Boolean(datosDelRecordset?.dom_fc_no_coincidente),
                                        f_apertura: normalizarFechaFormulario(datosDelRecordset?.f_apertura),
                                        activo: datosDelRecordset?.activo !== undefined ? datosDelRecordset.activo : 1,
                                        ip_maq: noNull(datosDelRecordset?.ip_maq),
                                        host_maq: noNull(datosDelRecordset?.host_maq),
                                        id_mov_web: noNull(datosDelRecordset?.id_mov_web),
                                        id_iglesia_madre: noNullNumber(datosDelRecordset?.id_iglesia_madre),
                                        id_iglesia: idIglesiaActual,
                                        fichero_culto : datosDelRecordset?.fichero_culto || null // Agregado por PS el 12/08/2026
                }
                // se hace un merge de los datos, los que son comunes se pisan y los nuevos se agregan


                                setObjetoInicializacion(prev => ({ ...prev, ...datosIglesia }))

                setDatosParaImpresiones(datosDelRecordset)

                //setContadorOperaciones(contadorOperaciones+1); // modifico contadorOperaciones para que se dispare el effect que busca materias e instrumentos una vez que se hayan cargado primero los datos del alumno. De esta forma ordeno secuencialmente la carga de datos y evito el warning de react "Can't perform a React state update on an unmounted component"
                setCargandoDatosIglesia(false)
                // bugsol 1
                // return datosDelRecordset // retorno un valor para que pueda hacerse algo en el .then ya que al ser async devuelva una promesa
            } catch (err) {

                console.log(err)
                // const mensaje_html = `<p>La busqueda de datos del alumno falló</p><p>${err.response.data.message}</p>`
                const mensaje_html = `${err}`
                Swal.fire({
                    html: mensaje_html,
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                })

                setCargandoDatosIglesia(false)
                setHuboError(true)
            }

        }

        if (tablasCargadas) { // este useEffect se dispara solo si ya se cargaron las tablas generales

            if (idIglesiaActual) { //  si se recibió el nùmero de alumno por propiedad es decir si es una modificación

                setTituloAbm(esVisualizacion ? `Visualizar la iglesia #${idIglesiaActual}` : `Editar la iglesia #${idIglesiaActual}`);
                setTituloCerrar('Cerrar la ficha de la iglesia');
                completarDatosDeLaIglesia(idIglesiaActual);

            }
            else { //  si no recibió el nùmero de curso por propiedad, es decir un alta
                setTituloAbm(`Crear una nueva Iglesia`);
                setTituloCerrar('Cancelar');
                hacerScroll("nuevo-Iglesia");

                // en administración permitimos alta de cualquier tipo de iglesia, copio tipos de iglesias como viene
                const tipoIglesiaPermitidaAlta = [...tiposIglesias]// filtrarRangoPermitidoParaAlta(tiposIglesias,setTiposIglesias)

                const regionPermitidaAlta = filtrarRegionPermitidaParaAlta(regiones, setRegiones, usuario.id_region)

                 setObjetoInicializacion({
                    ...objetoInicializacion,
                    id_tipo_iglesia: tipoIglesiaPermitidaAlta[0].id_tipo_iglesia,
                    id_region: regionPermitidaAlta
                })

                document.getElementById('abm-nombre_iglesia').focus()

            }

        }

    }, [tablasCargadas, idIglesiaActual, contadorModificaciones])

    useEffect(() => {

        if (!isShowing) {

            if (valoresFormulario) {
                console.log(valoresFormulario)
            }
        }

    }, [isShowing])

    const grabarIglesia = async (values) => {
        const idIglesiaPersistencia = Number(values.id_iglesia || idIglesiaActual || 0) || null;

        let resultado;
        let id_iglesia_interno;
        // me veo ogligado formatear el objeto que envío para grabar porque
        // los ids deben ser numéricos ya que se validan como números pero cuando el valor
        // viene de un "value" de un select por ejemplo se convierten a string
        // entonces antes de enviar el objeto hay que formatearlo

        if (esEdicionIglesia && !idIglesiaPersistencia) {
            Swal.fire('Error', 'No se detectó el id de la iglesia en edición. Cierre y vuelva a abrir la ficha antes de guardar.', 'error');
            return;
        }

    // Inicio agregado por PS el 12/08/2026 - Adjuntar fichero de culto en DigitalOcean Spaces

        // Registra las keys de los archivos subidos a Spaces durante esta operación.
        // Si posteriormente falla la grabación de la iglesia, el catch utiliza esta lista
        // para eliminar los archivos subidos y evitar dejar archivos huérfanos en uadspace.
        const archivosSubidos = [];

        let keyFicheroCultoAdjunto = null;

        // El adjunto se sube únicamente al editar una iglesia existente y cuando el usuario
        // seleccionó un nuevo archivo. idIglesiaActual se utiliza como parte del nombre/key
        // con el que se almacenará el archivo en DigitalOcean Spaces.
        if (idIglesiaActual && nuevoFicherCultoAdjunto) {

            // Sube el File almacenado en nuevoAdjunto a DigitalOcean Spaces.
            // Retorna: [keyAdjunto, resultadoOK, mensajeError]
            resultado = await subir_adjuntos_a_digitalocean_spaces(
                idIglesiaActual,
                nuevoFicherCultoAdjunto,
                archivosSubidos
            );

            // Si falla la subida, lanzamos el error para que sea procesado por el catch
            // general de grabarIglesia, donde también se realizará el rollback de los
            // archivos que hayan llegado a subirse correctamente.
            if (!resultado[1]) {
                throw new Error(resultado[2]);
            }

            // Guardamos la key devuelta por Spaces. Esta key identifica el archivo y es
            // el valor que posteriormente se persistirá en la base de datos.
            keyFicheroCultoAdjunto = resultado[0];
        }

    // Fin agregado por PS el 12/08/2026 - Adjuntar fichero de culto

        const objetoAgrabar = {
            nombre_iglesia: values.nombre_iglesia.trim(),
            direccion: values.direccion.trim(),
            barrio: values.barrio.trim(),
            localidad: values.localidad.trim(),
            cod_postal: values.cod_postal.trim(),
            fax: values.fax.trim(),
            telefono: values.telefono.trim(),
            pag_web: values.pag_web.trim(),
            email_secretaria: noNull(values.email_secretaria),
            email_tesoreria: noNull(values.email_tesoreria),
            email_pastor: noNull(values.email_pastor),
            id_provincia: Number(values.id_provincia),
            id_distrito: values.id_distrito ? Number(values.id_distrito) : null,
            id_partido: values.id_partido ? Number(values.id_partido) : null,
            id_pastor_UAD: values.id_pastor_UAD > 0 ? Number(values.id_pastor_UAD) : null,
            id_encargado_UAD: values.id_encargado_UAD > 0 ? Number(values.id_encargado_UAD) : null,
//            id_region: Number(usuario.id_region),   // en un alta de un Iglesia solo dejamos que se le asigne la región del usuario logueado     
            id_region: Number(values.id_region),   // en un alta de un Iglesia solo dejamos que se le asigne la región del usuario logueado             
            activo: values.activo !== undefined ? values.activo : 1,
            cant_miembros: values.cant_miembros,
            nombre_pastor: values.nombre_pastor.trim(),
            nombre_encargado: values.nombre_encargado.trim(),
            fich_culto: values.fich_culto,
            libro_cont: values.libro_cont,
            seguro: values.seguro,
            hab_municip: values.hab_municip,
            dispensario: values.dispensario,
            comedor: values.comedor,
            colegio: values.colegio,
            rehabilit: values.rehabilit,
            hogar_niños: values.hogar_niños,
            predio_recreat: values.predio_recreat,
            es_fundacion: values.es_fundacion,
            f_fundacion: values.f_fundacion || null,
            ente_dependiente: values.ente_dependiente,
            eximida_diezmos: values.eximida_diezmos,
            acta_afiliacion: noNull(values.acta_afiliacion),
            f_pres_acta_afil: values.activar_f_pres_acta ? values.f_pres_acta_afil : null,
            nro_acta_culto: noNull(values.nro_acta_culto),
            f_ing_minculto: values.f_ing_minculto || null,
            id_tipo_propiedad: values.id_tipo_propiedad ? Number(values.id_tipo_propiedad) : null,
            datos_catastrales: noNull(values.datos_catastrales),
            partida: noNull(values.partida),
            f_inicio_contrato: values.f_inicio_contrato || null,
            f_fin_contrato: values.f_fin_contrato || null,
            f_apertura: values.f_apertura || null,
            f_recepcion_secnac: values.f_recepcion_secnac || null,
            f_pedido_acta: values.f_pedido_acta || null,
            f_entrega_rnc: values.f_entrega_rnc || null,
            f_entrega_secnac: values.f_entrega_secnac || null,
            nmb_entrega_secnac: noNull(values.nmb_entrega_secnac),
            dir_entrega_secnac: noNull(values.dir_entrega_secnac),
            nro_filial: noNull(values.nro_filial),
            domicilio_fc: noNull(values.domicilio_fc),
            dom_fc_no_coincidente: values.dom_fc_no_coincidente,
            observaciones:values.observaciones,
            id_tipo_iglesia: Number(values.id_tipo_iglesia),
            id_usuario: usuario.id_usuario,
            ip_maq: noNull(values.ip_maq),
            host_maq: noNull(values.host_maq),
            id_mov_web: noNull(values.id_mov_web),
            id_iglesia_madre: values.id_iglesia_madre ? Number(values.id_iglesia_madre) : null,
            forzar_igl_principal: values.forzar_igl_principal,
            id_iglesia: idIglesiaPersistencia,
            fichero_culto:{ // agregad por ps el 12/08/2026
                            nuevo:keyFicheroCultoAdjunto || null,
                            anterior:objetoInicializacion?.fichero_culto || null,
                            eliminarActual:eliminarFicheroCultoAdjunto
                        } 
        }

        setGrabandoDatosIglesia(true)

        let mensaje_html = `<p>Los datos se grabaron exitosamente</p>`

        try {
            resultado = await Axios.post(`/api/tablasgenerales/v2/iglesia/crear`, objetoAgrabar)
            id_iglesia_interno = resultado.data.id_iglesia; // es el id del nuevo Iglesia 
            mensaje_html = `<p>Los datos de la iglesia se grabaron exitosamente</p>`

            Swal.fire({
                html: mensaje_html,
                icon: 'success',
                confirmButtonColor: '#3085d6',
            })

            setGrabandoDatosIglesia(false)

            if (esModal) {
                if (idIglesiaActual) { // si es modal y es una modificación
                    setContadorModificaciones(contadorModificaciones + 1)
                    finalizarAltaOcopia(false)
                } else { // si es modal y es un alta
                    finalizarAltaOcopia(true, id_iglesia_interno)
                }

            } else { // si no es modal
                finalizarAltaOcopia(true); // es una función que se ejecuta en el padre para ejecutar una acción luego de haber creado o copiado un curso
            }

        } catch (err) {
            console.log(err.response)
            let mensaje_html_error;

            // Inicio agregado por PS el 12/08/2026 por tema fichero de culto adjunto
            if (archivosSubidos.length > 0) {
                await eliminarArchivos(archivosSubidos);
            }
            // Fin agregado por PS el 12/08/2026 por tema fichero de culto adjunto

            if (err.response.data.message) {
                mensaje_html_error = `<p>Se produjo un error al grabar los datos de la iglesia</p><p>${err.response.data.message}</p>`
            } else if (err.response.data) {
                mensaje_html_error = `<p>Se produjo un error al grabar los datos de la iglesia</p><p>${err.response.data}</p>`
            } else {
                mensaje_html_error = `<p>Se produjo un error al grabar los datos de la iglesia</p><p>${err.response}</p>`
            }


            Swal.fire({
                html: mensaje_html_error,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            })

            setGrabandoDatosIglesia(false)
        }


    }

    const BusquedaPastor = (setFieldValue) => {
        setFieldValue('id_pastor_UAD', -1)
        setBuscarPastorUad(true)
    }

    const BusquedaEncargado = (setFieldValue) => {
        setFieldValue('id_encargado_UAD', -1)
        setBuscarEncargadoUad(setFieldValue)
    }

    const cerrarBusquedaPastor = () => {
        setBuscarPastorUad(false)
    }

    const cerrarBusquedaEncargado = () => {
        setBuscarEncargadoUad(false)
    }

    const finalizarSeleccion = (obrero, objetoModificacion) => {

        objetoModificacion.funcion(objetoModificacion.id, obrero.id_obrero)
        objetoModificacion.funcion(objetoModificacion.nombre, obrero.nom_simple)


        if (buscarPastorUad) {
            setBuscarPastorUad(false)
        }
        if (buscarEncargadoUad) {
            setBuscarEncargadoUad(false)
        }
    }

    const finalizarSeleccionProvincia = (obrero, objetoModificacion) => {

        objetoModificacion.funcion(objetoModificacion.id, obrero.id_provincia)


        setBuscarProvincias(false)
        toggle()


    }

    const obtenerDependencias = async () => {

        try {
            const { data } = await Axios.get(`/api/tablasgenerales/iglesia/dependientes/${idIglesiaActual ? idIglesiaActual : 0}`)

            setDependientes(data)

        } catch (err) {
            console.log(err)
        }
    }


    const iniciarDesvinculacion = (item) => {

        if (esVisualizacion) {
            alert('No es posible realizar la operación en modo visualización')
            return
        }

        if (!item.id) {
            alert('No se seleccionó un ministro para desvincular')
            return
        }

        Swal.fire({
            html: `<div><p>Desvinculando a ${item.nombre}</p><p class="mb-2 mt-2">¿Confirma la desvinculación?</p></div>`,
            showCancelButton: true,
            confirmButtonText: 'Desvincular',
            cancelButtonText: 'Cancelar'
        }).then(
            resultado => {
                if (resultado.value) {
                    desvincularMinistro(item);
                } else {
                    console.log("Se canceló la desvinculación del ministro")
                }
            }
        )
    }

    const eliminar = () => {

        if (esVisualizacion) {
            alert('No es posible eliminar la iglesia en modo visualización')
            return
        }

        Swal.fire({
            html: `<div><p class="mb-2 mt-2">¿Confirma la eliminación de la iglesia?</p></div>`,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(
               async resultado => {
                    if (resultado.value) {
                        try {
                            await Promise.all([Axios.delete(`/api/tablasgenerales/iglesia/${idIglesiaActual}/${usuario.nombre}`)])
                            alert('La iglesia fue eliminada exitosamente')
                            finalizarAltaOcopia(true)
                        } catch (error) {
                            console.log(error)
                            alert(error?.response?.data?.message || 'Se produjo un error al eliminar la iglesia')
                        }
                    }
            }
        )
    }



    const desvincularMinistro = async (item) => {

        console.log(item)
        let mensaje_html = `<p>Desvinculación exitosa</p>`

        try {

            const resultado = await Axios.delete(`/api/tablasgenerales/vinculos/baja/${item.id}`)

            Swal.fire({
                html: mensaje_html,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                timer: 1500
            }).then(() => {
                obtenerDependencias()
            })

        } catch (err) {
            console.log(err)
            let mensaje_html_error;

            if (err.response.data.message) {
                mensaje_html_error = `<p>Se produjo un error al grabar los datos del obrero</p><p>${err.response.data.message}</p>`
            } else if (err.response.data) {
                mensaje_html_error = `<p>Se produjo un error al grabar los datos del obrero</p><p>${err.response.data}</p>`
            } else {
                mensaje_html_error = `<p>Se produjo un error al grabar los datos del obrero</p><p>${err.response}</p>`
            }


            Swal.fire({
                html: mensaje_html_error,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            })

        }


    }

    const iniciarGrabarIglesia = (values) => {
        let texto;
        let textoConfirmacion;

        if (idIglesiaActual) {
            texto = `Confirma la modificación de la Iglesia
            ${idIglesiaActual}?`
            textoConfirmacion = 'Si, modificar la Iglesia'
        } else {
            texto = `Confirma la creación de la nueva iglesia? (${values.nombre_iglesia})`
            textoConfirmacion = 'Si, crear la iglesia'
        }

        Swal.fire({
            text: texto,
            showCancelButton: true,
            confirButtonText: textoConfirmacion,
            cancelButtonText: 'Cancelar'
        }).then(
            resultado => {
                if (resultado.value) {
                    grabarIglesia(values);

                } else {
                    console.log("Se canceló la modificación o creación de la iglesia")
                }
            }
        )
    }

    const escapeListaE = (e) => {
        if (e.keyCode === 27) {
            e.preventDefault();
            setBuscarEncargadoUad(false)
        }
    }

    const escapeListaP = (e,) => {
        if (e.keyCode === 27) {
            e.preventDefault();
            setBuscarPastorUad(false)
        }
    }

    const desvincular = (objetoModificacion) => {
        if (esVisualizacion) {
            alert('No es posible realizar la operación en modo visualización')
            return
        }
        objetoModificacion.funcion(objetoModificacion.id, 0)
        objetoModificacion.funcion(objetoModificacion.nombre, '')
    }

    const onsubmitIglesia = values => {
        console.log(values)
        iniciarGrabarIglesia(values)
    }

    if (huboError) {
        return <Main center>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <span>Se produjo un error al cargar los datos para esta vista</span>
            </div>
        </Main>
    }

    if (cargandoDatosTablasGenerales) {
        return <Main center>
            <div className='flex flex-col justify-center items-center mt-20'>
                <LoaderCircular className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando cargando datos generales...</span>
            </div>
        </Main>
    };

    if (cargandoDatosIglesia) {
        return <Main center>
            <div className='flex flex-col justify-center items-center mt-20'>
                <LoaderCircular className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando datos de la Iglesia...</span>
            </div>
        </Main>
    };

    const validationSchemaIglesia = Yup.object({

        nombre_iglesia: Yup.string().max(200, 'El nombre debe tener como máximo 100 caracteres')
            .required('Falta completar el nombre de la iglesia'),
        direccion: Yup.string().max(500, 'La dirección debe tener como máximo 500 caracteres'),
        localidad: Yup.string().max(200, 'La localidad debe tener como máximo 200 caracteres')
            .required('Falta completar la localidad'),
        cod_postal: Yup.string().max(10, 'El código postal debe tener como máximo 10 caracteres'),
        barrio: Yup.string().max(200, 'El barrio debe tener como máximo 200 caracteres'),
        telefono: Yup.string().max(200, 'El teléfono debe tener como máximo 200 caracteres'),
        fax: Yup.string().max(200, 'El fax debe tener como máximo 200 caracteres'),
        nombre_pastor: Yup.string().max(200, 'El nombre del pastor debe tener como máximo 200 caracteres'),
        nombre_encargado: Yup.string().max(200, 'El nombre del encargado debe tener como máximo 200 caracteres'),
        fich_culto: Yup.boolean().required(),
        libro_cont: Yup.boolean().required(),
        seguro: Yup.boolean().required(),
        hab_municip: Yup.boolean().required(),
        dispensario: Yup.boolean().required(),
        comedor: Yup.boolean().required(),
        colegio: Yup.boolean().required(),
        rehabilit: Yup.boolean().required(),
        hogar_niños: Yup.boolean().required(),
        predio_recreat: Yup.boolean().required(),
        cant_miembros: Yup.number().required('Falta indicar la cantidad de miembros. Mínimo 0 Máximo 10000').test("cant_miembros", 'La cantidad de miembros debe ser un número entre 0 y 10000', value => value >= 0 && value <= 10000),
        id_region: Yup.number().integer().required().test("nocero", "La región no es válida", value => value > 0),
        id_tipo_iglesia: Yup.number()
            .integer()
            .required('Falta seleccionar el tipo de iglesia')
            .test("nocero", "El tipo de iglesia no es válido", value => value > 0),
        id_provincia: Yup.number()
            .integer()
            .required('Falta seleccionar la provincia'),
        id_pastor_UAD: Yup.number().integer().required(),
        id_encargado_UAD: Yup.number().integer().required(),
        pastor_uad: Yup.boolean().required(),
        encargado_uad: Yup.boolean().required(),
        observaciones: Yup.string()
        .max(500, 'Las observaciones deben tener como máximo 500 caracteres'),
    })

    return (
        <Main>
            {grabandoDatosIglesia && <Main><div><Loading blanco={true} /><span className="cargando text-white">Grabando datos...</span></div></Main>}
            <div className={grabandoDatosIglesia ? "hidden" : `mx-auto w-full max-w-[95%] xl:max-w-[1400px] h-auto rounded flex flex-col lg:flex-row items-start justify-center mt-[-1rem] ${esCelular ? 'px-2' : 'px-4'}`} >
                <div className="flex w-full justify-center">

                   <div className="w-full">
                        
                        {/*el botòn de cancelar solo lo habilito cuando es un alta o copia*/}
                        <Formik validateOnMount={true} validateOnChange={true} validateOnBlur={true}
                            enableReinitialize={true} initialValues={objetoInicializacion}
                            validationSchema={validationSchemaIglesia} onSubmit={onsubmitIglesia} >
                            {({ values, errors, touched, handleChange, setFieldValue, resetForm, initialValues, dirty, validateForm, submitForm, setTouched }) => {
                                const manejarGuardarIglesia = async () => {
                                    const erroresValidacion = await validateForm()
                                    const camposConError = Object.keys(erroresValidacion)

                                    if (camposConError.length === 0) {
                                        submitForm()
                                        return
                                    }

                                    // marcar los campos con error como "touched" para que se vean los mensajes inline
                                    setTouched(camposConError.reduce((acc, campo) => ({ ...acc, [campo]: true }), {}))

                                    // llevar al usuario a la primera pestaña que contiene un error
                                    const primeraTabConError = camposConError
                                        .map((campo) => CAMPO_A_TAB_IGLESIA[campo])
                                        .find(Boolean)
                                    if (primeraTabConError) {
                                        setActiveTab(primeraTabConError)
                                    }

                                    const listaErrores = camposConError
                                        .map((campo) => erroresValidacion[campo])
                                        .filter(Boolean)

                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'No se puede guardar: faltan datos obligatorios',
                                        html: `<ul style="text-align:left;margin:0 auto;display:inline-block;padding-left:1.2em;">${listaErrores.map((msg) => `<li>${msg}</li>`).join('')}</ul>`,
                                    })
                                }

                                return (
                                    <Form id="ref-ficha">

                                        {isShowing && buscarProvincias && <Modal hide={toggle} isShowing={isShowing} estilo={esCelular ? { width: 'auto' } : { width: '700px' }} estiloWrapper={{ background: 'transparent' }}>
                                            <BusquedaProvincias finalizarSeleccion={finalizarSeleccionProvincia} objetoModificacion={{ funcion: setFieldValue, id: 'id_provincia', nombre: 'nombre_encargado' }} />
                                        </Modal>}

                                        {!esVisualizacion && <div className="sticky top-0 z-50 py-3 flex flex-row items-center justify-between mb-4 border-b border-gray-200" style={{backgroundColor: '#e5e7eb', margin: '-1rem -1rem 1rem -1rem', padding: '1rem', top: '-1rem'}}>
                                            <div className="flex items-center">
                                                <GoBack titulo="" callback={finalizarIglesiaSeleccionado} onClick={() => resetForm(initialValues)}/>
                                                <Typography
                                                    variant="h5"
                                                    color="blue-gray"
                                                    className="font-medium mt-1 hidden sm:block"
                                                >
                                                    Volver a tabla de Iglesias
                                                </Typography>
                                            </div>
                                            <div>
                                            </div>
                                        </div>}

                                        <div className="mb-2">
                                            <div className="flex f-row">
                                                <Typography
                                                    variant="h5"
                                                    color="blue-gray"
                                                    className="font-medium mt-4"
                                                >
                                                    {tituloAbm}
                                                </Typography>
                                            </div>
                                        </div>

                                        {/* Inicio agregado por PS el 12/08/2026 por tema fichero de culto adjunto */}
                                        {/*
                                                    Panel para visualizar o reemplazar el fichero de culto adjunto.

                                                    Solo se muestra cuando la iglesia ya existe (idIglesiaActual).

                                                    Si existe un archivo previamente guardado, "url" contiene su key de Spaces
                                                    y traerUrl() permite obtener/abrir el archivo.

                                                    Cuando el usuario selecciona un nuevo archivo, PanelAdjuntosDinamico NO lo
                                                    sube inmediatamente a Spaces. El objeto File seleccionado queda almacenado
                                                    en el estado "nuevoAdjunto" mediante setNuevoAdjunto().

                                                    La subida efectiva a DigitalOcean Spaces se realiza posteriormente dentro
                                                    de grabarIglesia(), al ejecutar subir_adjuntos_a_digitalocean_spaces().
                                        */}
                                        {idIglesiaActual && 
                                        
                                            <div className='flex'>
                                                <div className={eliminarFicheroCultoAdjunto ? 'line-through blink flex flex-col' : ''}>
                                                    <PanelAdjuntosDinamico 
                                                        titulo="Fichero de culto"
                                                        url={objetoInicializacion?.fichero_culto}
                                                        editando={cambiarFicheroCultoAdjunto}
                                                        nuevoArchivo={nuevoFicherCultoAdjunto}
                                                        setEditando={setCambiarFicheroCultoAdjunto}
                                                        setNuevoArchivo={setNuevoFicheroCultoAdjunto}
                                                        removeClasses={true}                                      
                                                        traerUrl={traerUrl}
                                                        icono={true}
                                                        deshabilitado={!esEdicionIglesia || eliminarFicheroCultoAdjunto}
                                                    />
                                                </div>
                                               <HandleEliminacionAdjunto
                                                    objetoInicializacion={objetoInicializacion}
                                                    nuevoFicherCultoAdjunto={nuevoFicherCultoAdjunto}
                                                    eliminarFicheroCultoAdjunto={eliminarFicheroCultoAdjunto}
                                                    setEliminarFicheroCultoAdjunto={setEliminarFicheroCultoAdjunto}
                                               />
                                            </div>} 
                                        {/* Fin agregado por PS el 12/08/2026 por tema fichero de culto adjunto */}

                                        <div className="flex f-col mt-2 mb-4 bg-white p-3 rounded-md shadow-sm border border-gray-100">
                                            <Typography variant="small" color="blue-gray" className="mb-1 font-bold text-base">
                                                Nombre de la iglesia
                                            </Typography>
                                            <Field
                                                id="abm-nombre_iglesia"
                                                type="text"
                                                autoComplete="off"
                                                maxLength="100"
                                                disabled={esVisualizacion}
                                                name="nombre_iglesia"
                                                onFocus={() => seleccionarTextoInput("abm-nombre_iglesia")}
                                                onClick={() => seleccionarTextoInput("abm-nombre_iglesia")}
                                                className={`input-ui-data hide-browser-input-decoration ${values.nombre_iglesia ? 'input-cvalor' : 'input-vacio'} text-base py-2 ${esVisualizacion ? 'bg-gray-100' : ''}`}
                                            />
                                            <div className="error_formulario"><ErrorMessage name="nombre_iglesia" /></div>
                                        </div>
                                        {idIglesiaActual && dirty && !esVisualizacion &&
                                            <Button type="button"
                                                className="cursor-pointer w-32 mb-2"
                                                onClick={() => resetForm(initialValues)}>
                                                Restaurar
                                            </Button>
                                        }
                                        <Tabs value={activeTab} className="max-w-full mt-4 bg-transparent border-none">
                                            <div className="overflow-x-auto w-full overflow-y-hidden pb-2 mx-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                                                <TabsHeader
                                                    className="bg-blue-gray-50/70 p-1.5 flex-nowrap min-w-max border border-blue-gray-100/50 shadow-sm"
                                                    indicatorProps={{
                                                        className: "bg-gradient-to-tr from-blue-600 to-blue-500 shadow-md !text-white rounded-md",
                                                    }}
                                                >
                                                    <Tab value="datos_personales" onClick={() => setActiveTab('datos_personales')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'datos_personales' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>Datos personales</Tab>
                                                    <Tab value="datos_contacto" onClick={() => setActiveTab('datos_contacto')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'datos_contacto' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>Datos de contacto</Tab>
                                                    <Tab value="datos_institucionales" onClick={() => setActiveTab('datos_institucionales')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'datos_institucionales' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>Datos institucionales</Tab>
                                                    {esEdicionIglesia && <Tab value="datos_contables" onClick={() => setActiveTab('datos_contables')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'datos_contables' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>Datos contables</Tab>}
                                                    {esEdicionIglesia && values.ente_dependiente && <Tab value="ministros_dependientes" onClick={() => setActiveTab('ministros_dependientes')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'ministros_dependientes' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>Ministros dependientes</Tab>}
                                                    {esEdicionIglesia && <Tab value="datos_bancarios" onClick={() => setActiveTab('datos_bancarios')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'datos_bancarios' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>Datos bancarios</Tab>}
                                                    {esEdicionIglesia && <Tab value="fichero_culto" onClick={() => setActiveTab('fichero_culto')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'fichero_culto' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>Certificado de Local Filial</Tab>}
                                                </TabsHeader>
                                            </div>
                                            <TabsBody>
    {/* TAB 1: Datos Personales */}
    <TabPanel value="datos_personales">
        <TabDatosPersonales
            values={values}
            esVisualizacion={esVisualizacion}
            setFieldValue={setFieldValue}
            handleChange={handleChange}
            id_iglesia={idIglesiaActual}
            buscarPastorUad={buscarPastorUad}
            desvincular={desvincular}
            escapeListaP={escapeListaP}
            BusquedaPastor={BusquedaPastor}
            cerrarBusquedaPastor={cerrarBusquedaPastor}
            finalizarSeleccion={finalizarSeleccion}
            buscarEncargadoUad={buscarEncargadoUad}
            escapeListaE={escapeListaE}
            BusquedaEncargado={BusquedaEncargado}
            cerrarBusquedaEncargado={cerrarBusquedaEncargado}
            regiones={regiones}
            tiposIglesias={tiposIglesias}
        />
    </TabPanel>

    {/* TAB 2: Datos de Contacto */}
    <TabPanel value="datos_contacto">
        <TabDatosContacto
            values={values}
            esVisualizacion={esVisualizacion}
            handleChange={handleChange}
            provincias={provincias}
            setBuscarProvincias={setBuscarProvincias}
            toggle={toggle}
        />
    </TabPanel>

    {/* PLaceholders for the other ones temporarily, as per the issue description 'comenzando con los 2 primeros tabs' */}
    <TabPanel value="datos_institucionales">
        <TabDatosInstitucionales
            values={values}
            esVisualizacion={esVisualizacion}
            setFieldValue={setFieldValue}
            setActiveTab={setActiveTab}
        />
    </TabPanel>
    {esEdicionIglesia && <TabPanel value="datos_contables">
    <TabDatosContables 
        values={values} 
        handleChange={handleChange} 
        esVisualizacion={esVisualizacion}
        balances={balances}
        handleEliminarBalance={handleEliminarBalance}
        periodosBalance={periodosBalance}
        nuevoBalancePeriodo={nuevoBalancePeriodo}
        setNuevoBalancePeriodo={setNuevoBalancePeriodo}
        nuevoBalanceFecha={nuevoBalanceFecha}
        setNuevoBalanceFecha={setNuevoBalanceFecha}
        handleAgregarBalance={handleAgregarBalance}
        diezmos={diezmos}
    />
</TabPanel>}
    {esEdicionIglesia && values.ente_dependiente && <TabPanel value="ministros_dependientes">
    <TabMinistrosDependientes 
        esVisualizacion={esVisualizacion}
        nuevoMinistroSeleccionado={nuevoMinistroSeleccionado}
        setNuevoMinistroSeleccionado={setNuevoMinistroSeleccionado}
        obrerosUad={obrerosUad}
        handleAgregarMinistroInfo={handleAgregarMinistroInfo}
        ministrosDependientes={ministrosDependientes}
        handleEliminarMinistroInfo={handleEliminarMinistroInfo}
    />
</TabPanel>}
    {esEdicionIglesia && <TabPanel value="datos_bancarios">
    <TabDatosBancarios 
        esVisualizacion={esVisualizacion}
        cuentasBancarias={cuentasBancarias}
        setCuentaActiva={setCuentaActiva}
        cuentaActiva={cuentaActiva}
        handleEliminarCuentaBancaria={handleEliminarCuentaBancaria}
        bancosList={bancosList}
        tiposCuentasList={tiposCuentasList}
        handleGuardarCuentaBancaria={handleGuardarCuentaBancaria}
        handleFirmanteChange={handleFirmanteChange}
        cuentaInit={typeof cuentaInit !== "undefined" ? cuentaInit : null} // avoid crash
    />
</TabPanel>}
    {esEdicionIglesia && <TabPanel value="fichero_culto">
          <TabFicheroCulto values={values} handleChange={handleChange} setFieldValue={setFieldValue} esVisualizacion={esVisualizacion} />
      </TabPanel>}
  </TabsBody>
                                        </Tabs>
                                        <div className="mt-8 pt-5 border-t border-gray-200 flex flex-row items-center justify-end space-x-4">
                                            {usuario.perfil=='sede' && usuario.rol_sede > 96 &&  <Button 
                                                title='Eliminar la iglesia' 
                                                className="flex items-center px-8 py-2.5 shadow-md hover:shadow-lg text-sm bg-[#e01] text-white rounded-md"
                                                type="button"
                                                onClick={eliminar}>
                                                    <TrashIcon width={20} strokeWidth={2} className="mr-2"/>
                                                    ELIMINAR
                                            </Button>}
                                            {!esVisualizacion && <Button variant="gradient" color="blue" className="flex items-center px-8 py-2.5 shadow-md hover:shadow-lg text-sm bg-blue-500 hover:bg-blue-600 rounded-md" type="button" onClick={manejarGuardarIglesia}><CheckIcon className="w-5 h-5 mr-2" strokeWidth={2.5} /> GUARDAR</Button>}
                                        </div>
                                    </Form>)
                            }}

                        </Formik>
                    </div>

                </div>


            </div>

            <ReactTooltip id="tooltip_n_pastor"
                type="">
                <p>Escriba el nombre del pastor para seleccionarlo en la lista de obreros UAD</p>
                <br></br>
                <p>Si no es un obrero UAD solo escriba su nombre y luego click en Aceptar</p>
            </ReactTooltip>

            <ReactTooltip id="tooltip_n_encargado"
                type="">
                <p>Escriba el nombre del encargado para seleccionarlo en la lista de obreros UAD</p>
                <br></br>
                <p>Si no es un obrero UAD solo escriba su nombre y luego click en Aceptar</p>
            </ReactTooltip>

            <ReactTooltip id="tooltip_n_pastor_normal" type="">
                Normal
            </ReactTooltip>
            <ReactTooltip id="eliminar-adjunto" type="">
                El archivo se va a eliminar definitivamente de la base de datos.
            </ReactTooltip>
        </Main>
    )
}

function SpinnerDiezmo({ item, todos }) {

    /* const maximo = todos.map(item=>item.cantidad).sort((a,b)=>b-a)[0]
     let nueva_altura = (Number(maximo)) + 20 // antes era 140
 
     if (nueva_altura > 150) {
         nueva_altura = 150
     }
 */
    const convertirFormato = (numero) => {
        let numeroConPunto = numero.replace(/,/g, '.');
        let numeroEnNuevoFormato = numeroConPunto.replace(/\.(?=[^.]*$)/, ',');
        return numeroEnNuevoFormato;
    }

    let valor = Number(item.diezmo)

    let diezmo = Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(valor)
    var diezmoFormat = diezmo.replace(/[€]/g, '');

    const total = todos.reduce((ac, item) => { return ac + Number(item.diezmo) }, 0)
    const porcentaje = ((Number(valor) / Number(total)) * 100).toFixed(1)
    const maximo = todos.map(item => item.cantidad).sort((a, b) => b - a)[0]

    return (
        <div>
            <svg width="70" height={110} fontFamily="sans-serif" fontSize="10" textAnchor="end">

                {valor > 0 && <rect x="0" y={100 - porcentaje * 3} fill={valor == 1 ? "red" : "steelblue"} width="60" height={porcentaje * 3}></rect>}

                {valor == 0 && <rect x="0" y={108} fill="red" width="60" height="20"></rect>}
                <text fill="black" x="60" y={60}>{diezmoFormat}</text>

            </svg>
        </div>

    );
}

function hacerScroll(id) {
    let element = document.getElementById(id);

    if (!element) { return }
    element.scrollIntoView(false);
}

function noNull(valor) {
    if (!valor) {
        return ''
    } else {
        return valor.trim()
    }
}

function noNullNumber(valor) {
    if (!valor) {
        return 0
    } else {
        return valor
    }
}

function filtrarRangoPermitidoParaAlta(tiposIglesias, setTipoIglesia) {
    const tiposPermitidos = tiposIglesias.filter(item => item.nombre.includes('trámite regional'))
    setTipoIglesia(tiposPermitidos)

    if (tiposPermitidos.length > 0) {
        return tiposPermitidos[0].id_tipo_iglesia
    } else {
        return null
    }
}

function filtrarRegionPermitidaParaAlta(regiones, setRegiones, id_region_usuario) {
    const regionesPermitidas = regiones.filter(item => item.id_region === id_region_usuario)
    if (regionesPermitidas.length > 0) {
        return regionesPermitidas[0].id_region
    } else {
        return regiones[0].id_region // pablo 26/06/2025
    }
}

function ListaDependientes({ dependientes, iniciarDesvinculacion }) {
    return <div className="FormAbmContainer flex justify-left f-col ml-2 mb-2">
        <div className="w-full">
            <Typography
                variant="h5"
                className="font-medium"
            >
                Dependientes ({dependientes.length}):
            </Typography>
            <div className="grid grid-cols-3 gap-1 mt-2">
                {dependientes.map(item =>
                    <div>
                        <Button variant="text" className="flex text-small" onClick={() => iniciarDesvinculacion(item)}
                            title="Desvincular al ministro">
                            <XCircleIcon width={20} />
                            <span className='ml-2 mt-1 text-left'>{item.nombre}</span>
                        </Button>
                    </div>)
                }
            </div>
        </div>
    </div>
}

function ListaBalancesDiezmos({ balances, diezmos, id_iglesia }) {
    return <div className="FormAbmContainer flex f-col ml-2 md:w-60">
        <div className="flex f-col">
            <Typography
                variant="h6"
                className="mb-1 font-medium "
            >
                Archivos adjuntos:
            </Typography>
            <Adjuntos id_iglesia={id_iglesia} />
        </div>
        <div className="flex f-col">
            <Typography
                variant="h6"
                className="mb-1 font-medium mt-4"
            >
                Balances:
            </Typography>
            {balances.map(item => <span className={item.estado == 0 ? 'bal-np !text-[15px]' : 'bal-pr !text-[15px]'}>{item.periodo}</span>)}
        </div>
        <div className="flex f-col">
            <Typography
                variant="h6"
                className="mb-1 font-medium mt-4"
            >
                Diezmos:
            </Typography>
            {diezmos.map(item => <div className="diezmos"><span className={Number(item.diezmo) > 0 ? "dm-pr w-full !text-[15px]" : 'dm-np w-full !text-[15px]'}>{item.periodo}</span></div>)}
        </div>
        {diezmos.length == 0 && <span className="dm-np text-sm font-bold">0.00</span>}
    </div>
}

const Adjuntos = ({ id_iglesia }) => {
    const [adjuntos, setAdjuntos] = React.useState(null);
    const [error, setError] = React.useState(null);

    useEffect(() => {
        buscarAdjuntos(id_iglesia);
    }, [])

    const buscarAdjuntos = async (id) => {
        try {
            const { data } = await Axios.get(`/api/tablasgenerales/iglesia/adjuntos/${id}`)
            console.log('checking', JSON.stringify(data))
            setAdjuntos(data)
        } catch (err) {
            console.log('Error al buscar los adjuntos de la iglesia', err)
            setError(err?.response?.data?.message || err?.message || JSON.stringify(err))
        }
    }

    if (error) {
        return <div>
            <p title={error}>Hay errores</p>
        </div>
    }

    return <div>
        {!adjuntos && <p className='text-center'>Ninguno</p>}
        {adjuntos && <div>
            {adjuntos?.acta_autonomia && <p><span title='Visualice el acta de autonomía' className='cursor-pointer text-blue-300 text-sm font-bold' onClick={() => traerAbrirUrl(adjuntos?.acta_autonomia)}>Acta de autonomía</span></p>}
            {adjuntos?.acta_afip && <p><span title='Visualice el acta afip de afiliación' className='cursor-pointer text-blue-300 text-sm font-bold' onClick={() => traerAbrirUrl(adjuntos?.acta_afip)}>Acta afip</span></p>}
        </div>}
    </div>
}

const actas = (datosParaImpresiones)=>{

    if(!datosParaImpresiones?.acta_afiliacion){
        return 'No posee'
    }

    if(!datosParaImpresiones?.f_pres_acta_afil){
        return `${datosParaImpresiones?.acta_afiliacion} (Fecha indefinida)`
    }

    return `${datosParaImpresiones?.acta_afiliacion} (${transformarIso8601(datosParaImpresiones?.f_pres_acta_afil)})`
}

const subir_adjuntos_a_digitalocean_spaces = async (idIglesiaActual,nuevoAdjunto,archivosSubidos)=>{
    // Esta función almacena en DigitalOcean Spaces el archivo seleccionado que se encuentra
    // temporalmente en memoria en nuevoAdjunto. Si la subida es exitosa devuelve la key
    // generada en Spaces, que luego puede almacenarse en la base de datos.
    // archivosSubidos mantiene un registro de las keys subidas durante la operación para
    // poder eliminarlas posteriormente si falla el proceso de grabación de la iglesia.

    let keyAdjunto = null;

        if (idIglesiaActual && nuevoAdjunto) {

            const resultadoAdjunto = await subirAdjunto(
                nuevoAdjunto,
                idIglesiaActual,
                'igl_fich_culto',
                archivosSubidos
            );

            if (!resultadoAdjunto[0]) {
                return [keyAdjunto,false,resultadoAdjunto[1]]
            }

            keyAdjunto = resultadoAdjunto[1].acta;
            if (keyAdjunto && !archivosSubidos.includes(keyAdjunto)) {
                archivosSubidos.push(keyAdjunto);
            }
        }

    return [keyAdjunto,true,null]

}

const HandleEliminacionAdjunto = ({objetoInicializacion,nuevoFicherCultoAdjunto,eliminarFicheroCultoAdjunto,setEliminarFicheroCultoAdjunto})=>{

    if(!(objetoInicializacion?.fichero_culto  && !nuevoFicherCultoAdjunto))
    {return null}

    return <div className='flex flex-col ml-3'>
        {eliminarFicheroCultoAdjunto && <span className="text-red-400">El archivo será eliminado al guardar</span>}
        <Typography 
                data-for="eliminar-adjunto" 
                data-tip
                onClick={() => setEliminarFicheroCultoAdjunto(!eliminarFicheroCultoAdjunto)}
                variant="small"
                className={`font-medium cursor-pointer transition-colors duration-150 inline-flex items-center gap-1 ${
                    eliminarFicheroCultoAdjunto 
                    ? 'text-gray-600 hover:text-gray-800' 
                    : 'text-red-600 hover:text-red-800'
                }`}
                >
                {/* Cambia el ícono dinámicamente */}
                {eliminarFicheroCultoAdjunto ? (
                    <XCircleIcon className="w-4 h-4" />
                ) : (
                    <TrashIcon className="w-4 h-4" />
                )}
                
                {eliminarFicheroCultoAdjunto ? 'Cancelar eliminación' : 'Eliminar definitivamente'}
        </Typography>
    </div>
    

}